<div class="h-full w-full si-card">
    <div class="border-b px-4 py-2 flex items-center justify-between">
        <h3 class="pt-2">News Alerts</h3>
        <ng-container *ngIf="newsAutomationsAgents?.length !== 0">
            <div class="flex grow-0 items-center">
              @if (!hideAgentSelector) {
              <div [matTooltip]="selectedScope === 'all' ? 'Agent dropdown only available when the Current User is selected.': ''">
                <button matButton="outlined" type="button"
                        class="mr-1 card-menu si-menu-trigger" [matMenuTriggerFor]="intentAgentsMenu"
                        [disabled]="selectedScope === 'all'" >
                  <span class="si-card-menu-content">
                    <span class="si-card-menu-label">{{ selectedOption?.name || 'Agent Name' }}</span>
                    <span class="si-menu-trigger-icon" aria-hidden="true"></span>
                  </span>
                </button>
              </div>

                <mat-menu #intentAgentsMenu>
                    <ng-template matMenuContent>
                        <button mat-menu-item (click)="updateSelectedOption(null)">
                            Agent Name
                        </button>
                        <button mat-menu-item *ngFor="let agent of newsAutomationsAgents" (click)="updateSelectedOption(agent)">
                            {{agent.name}}
                        </button>
                    </ng-template>
                </mat-menu>
                }
                <mat-button-toggle-group name="type" class="mr-1 card-toggle-btn" [disabled]="isWeeklyAgentsNotRun">
                    <mat-button-toggle value="CHART" [checked]="isShowChart" (change)="isShowChart = true"
                        class="flex items-center">
                        <fa-icon matTooltip="Chart" class="si-icon" [icon]="['fal', 'chart-column']"></fa-icon>
                    </mat-button-toggle>
                    <mat-button-toggle value="TABLE" [checked]="!isShowChart" (change)="isShowChart = false"
                        class="flex items-center">
                        <fa-icon matTooltip="Table" class="si-icon" [icon]="['fal', 'table']"></fa-icon>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </ng-container>
    </div>

    <div class="pt-4 px-4">
        <p class="card-sub-header-text w-full mb-1">
            {{ newsAutomationsAgents?.length !== 0 ? 'News articles sent over the past 4 weeks' : '\u00A0' }}
        </p>

        <mat-radio-group aria-label="Select an option" class="text-center flex justify-center"
            [value]="selectedScope" (change)="onUserScopeChange($event.value)" *ngIf="!hideAgentSelector && !(selectedScope === 'all' && newsAutomationsAgents?.length === 0 && !isLoading )">
            <mat-radio-button value="all" class="mx-2">All Users</mat-radio-button>
            <mat-radio-button value="current" class="mx-2">Current User</mat-radio-button>
        </mat-radio-group>
    </div>


    <div class="h-full" *ngIf="!newsAutomationsAgents || isLoading; else newsAutomationCard">
        <div class="flex justify-center items-center h-full w-full">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <ng-template #newsAutomationCard>
        <ng-container *ngIf="newsAutomationsAgents?.length === 0">
            <ng-container *ngIf="featureFlagsEnum.GTMCanvas | isFeatureFlagEnabled | async; else legacyLink">
                <div class="h-full w-full p-4 content-center text-center font-bold">
                    <h5>You do not currently have any News Agents created.</h5>
                    <p class="text-base text-muted">
                        <a [routerLink]="resultTabsetUrlsEnum.AGENTIC_WORKFLOWS">Create a News Agent</a>
                        to be alerted about new events and changes at companies that are important to you.
                    </p>
                </div>
            </ng-container>
            <ng-template #legacyLink>
                <div class="flex pb-12 px-6 flex-wrap justify-center content-center h-full pt-6">
                    <p class="text-center pb-2 text-secondary empty-state-text pt-1 font-light">
                        You do not have any News Agents configured on your account.
                    </p>
                    <p class="text-center pb-2 text-secondary w-3/4 empty-state-text font-light">
                        Check out our <a
                            href="https://support.salesintel.io/hc/en-us/articles/27414287595417-Use-News-Automations"
                            target="_blank" class="text-primary">help article</a> to learn how to set up News Agents.
                    </p>
                </div>
            </ng-template>
        </ng-container>
        <ng-container *ngIf="newsAutomationsAgents?.length !== 0">
            <div class="flex w-full h-full flex-col p-4 items-center overflow-hidden">
                <ng-container *ngIf="isShowChart; then chartPlaceholder; else tablePlaceholder" class="h-full w-full"></ng-container>
            </div>
        </ng-container>

        <ng-template #chartPlaceholder>
            <div class="flex flex-col h-full w-full overflow-hidden">
              <app-bar-chart
                class="flex flex-col w-full h-full"
                [chartLabels]="chartDataLabels"
                [chartData]="chartData"
                [showDataLabel]="true"
                [showHorizontalGridLines]="true"
                [showTooltips]="false"
                [ngClass]="tableClass"
                [useAbbreviationYAxis]="true"
              ></app-bar-chart>
            </div>
          </ng-template>

          <ng-template #tablePlaceholder>
            <div class="h-full w-full flex flex-col overflow-hidden">
              <app-data-table
                [data]="newsAutomationData"
                [columns]="columns"
                sortActive="eventDate"
                sortDirection="asc"
                smallRowHeight="true"
                [layoutFixed]="false"
              ></app-data-table>
            </div>
          </ng-template>
    </ng-template>

</div>
